import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location, AsyncPipe } from '@angular/common';
import { ORIGINAL_URL_QUERY_PARAM } from '@skyeng/libs/vimbox-core/routing';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { TypografModule } from '@skyeng/libs/skypro/misc';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';

@Component({
  selector: 'app-page-403',
  templateUrl: 'page-403.html',
  styleUrls: ['page-403.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DsButtonModule, AsyncPipe, TypografModule, TranslocoModule],
})
export class Page403Component implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private translocoService = inject(TranslocoService);

  text$: Observable<string>;
  queryParams$: Observable<Params>;

  ngOnInit(): void {
    // https://github.com/angular/angular/issues/17004#issuecomment-414459149
    const originalUrl = this.activatedRoute.snapshot.queryParams[ORIGINAL_URL_QUERY_PARAM];

    if (originalUrl) {
      this.location.replaceState(originalUrl);
    }

    this.text$ = this.activatedRoute.queryParams.pipe(
      map(queryParams => {
        return queryParams.text || this.translocoService.translate('skyproRoutingPage.notEnoughRights');
      }),
    );
  }
}
